/**
 * @voltxampere/ui — DHT22 / AM2302 humidity + temperature sensor variant (Sprint 43-6, placeholder)
 *
 * PLACEHOLDER. Higher-precision sibling of DHT11. Range 0-100 % RH
 * (±2 %) and -40 to +80 °C (±0.5 °C). Real protocol simulation
 * lands Sprint 47+.
 *
 * Reference: Aosong DHT22 (AM2302). Vcc 3.3-6 V, single-wire
 * bidirectional data line, 0.5 Hz sample rate.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorDht22 = {
    id: "dht22",
    nameTr: "DHT22 / AM2302 (Hassas Nem + Sıcaklık, placeholder)",
    nameEn: "DHT22 / AM2302 (Precision Humidity + Temperature, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "DHT22",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-dht22.js.map